import React from "react";

import {
    FaKey,
    FaServer
} from "react-icons/fa";


class LicenseCard extends React.Component {


    render(){


        const {

            installations = []

        } = this.props;



        const maxInstallations = 3;


        const activeInstallations =
            installations.filter(
                item =>
                item.status === "ACTIVE"
            ).length;



        const percentage =
            (activeInstallations / maxInstallations) * 100;



        const available =
            maxInstallations - activeInstallations;



        return (


            <div className="idms-card">


                <div className="card-header">


                    <div>


                        <h2 className="card-title">

                            MT5 License & Installations

                        </h2>


                        <p className="card-subtitle">

                            Manage your connected MetaTrader 5 Expert Advisors

                        </p>


                    </div>


                    <FaKey

                        className="header-icon"

                    />


                </div>





                <div className="license-progress-container">


                    <div className="license-progress-header">


                        <span>

                            Active Installations

                        </span>


                        <strong>

                            {activeInstallations} / {maxInstallations}

                        </strong>


                    </div>





                    <div className="license-progress">


                        <div

                            className="license-progress-bar"

                            style={{
                                width:`${percentage}%`
                            }}

                        />


                    </div>



                </div>





                <div className="license-summary">


                    <div>


                        <FaServer />


                        <span>

                            Available Slots

                        </span>


                    </div>


                    <strong>

                        {available}

                    </strong>


                </div>




            </div>


        );


    }


}



export default LicenseCard;